import { useMutation } from "@apollo/client/react";import React, { useEffect } from 'react';
import './indicacionDetalle.scss';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import { SAVE_RESPUESTA } from '../../../../data/graphQL/mutations/AdminIndicacion/SaveRespuesta';

import { TextInput } from '../../../../components/textInput/TextInput';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { SelectInput } from '../../../../components/selectInput/SelectInput';

export const IndicacionDetalleRespMedica = ({ data, setDataDetalle, estados, edit }) => {

  const navigate = useNavigate();

  const ESTADO_PENDIENTE = 1;
  const ESTADO_RECHAZADO = 4;

  const handleChange = (e) => {
    const { value, name } = e.target;
    setDataDetalle((data) => ({ ...data, [name]: value }));
  };

  useEffect(() => {
    setDataDetalle((data) => ({ ...data, "idEstadoMedico": data.idEstadoMedico }));
  }, []);

  const isFormValid = () => {
    if (data.idEstadoMedico == ESTADO_PENDIENTE) {
      toast.error('El estado debe ser distinto de Pendiente.');
      return false;
    }
    // justificación obligatoria en caso de rechazo
    if (data?.idEstadoMedico == ESTADO_RECHAZADO && data.observacionMedico == "") {
      toast.error('El motivo es obligatorio.');
      return false;
    }
    return true;
  };

  const [saveRespuesta, { loading: saveLoading }] = useMutation(SAVE_RESPUESTA, {
    onCompleted: (data) => {
      if (data?.saveJustificacionIndicacionAprobacion.success) {
        toast.success("Se guardaron los cambios correctamente.");
        setTimeout(() => navigate('/adminIndicacion'), 1000);
      } else {
        toast.error("Se produjo un error al grabar la respuesta.");
      }
    }
  });

  const handleGuardar = () => {
    if (isFormValid()) {
      saveRespuesta({ variables: { input: {
            idIndicacionAprobacion: data?.idIndicacionAprobacion,
            idEvaluacion: parseInt(data?.contratoActual, 10),
            tipo: "M",
            idEstado: data?.idEstadoMedico,
            observacion: data?.observacionMedico
          } } });
    }
  };

  return (
    <>
            <Grid container className='contrato-card-white'>
                <Grid size={{ xs: 12 }}>
                    <div className='section-title'>Respuesta médica</div>
                </Grid>
                <Grid container spacing={2} size={{ xs: 12 }}>
                    <Grid size={{ xs: 24, sm: 12, md: 3, lg: 3 }}>
                        <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">
                        <SelectInput
                options={estados}
                label='Estados'
                onChange={handleChange}
                value={data?.idEstadoMedico}
                name='idEstadoMedico'
                margin={'normal'}
                disabled={!edit} />
              
                        </FormControl>
                    </Grid>                
                    <Grid size={{ xs: 24, md: 12, lg: 12 }}>
                        <TextInput
              value={data?.observacionMedico}
              multiline
              rows={3}
              maxLength={2000}
              label='Motivo'
              name="observacionMedico"
              onChange={handleChange}
              disabled={!edit} />
            
                    </Grid>
                    {
          edit &&
          <Grid size={{ xs: 24, md: 12, lg: 12 }}>
                            <CustomButton
              variant='outlined'
              onClick={handleGuardar}
              size='small'
              isLoading={saveLoading}>
              
                                Grabar
                            </CustomButton>
                        </Grid>
          }                
                </Grid>
            </Grid>
        </>);

};